export default "__VITE_ASSET__DzfTO5A5__"